/**
 * Sets defaults for all theme options.
 */

const CONTACT_INFO = {
  contact: {
    email: "",
    address: {
      street: "",
      city: "",
      state: "",
      zip: "",
    },
    phone: "",
  },
  businessName: "DUQE",
  googleMapsLink: "",
  socialFollowLinks: [
    { name: "dribbble", url: null },
    { name: "facebook", url: "https://www.facebook.com/duqe.ae" },
    { name: "github", url: null },
    { name: "instagram", url: "https://www.instagram.com/duqe.ae/" },
    { name: "linkedin", url: "https://www.linkedin.com/company/duqeae/" },
    { name: "medium", url: null },
    { name: "pinterest", url: null },
    { name: "reddit", url: null },
    { name: "snapchat", url: null },
    { name: "soundcloud", url: null },
    { name: "tiktok", url: null },
    { name: "twitter", url: null },
    { name: "vimeo", url: null },
    { name: "youtube", url: null },
  ],
}

module.exports = CONTACT_INFO
